import './styles.scss'
import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Accordion, AccordionTab } from 'primereact/accordion'
import { Toast } from 'primereact/toast'
import { DoubleArrowIcon, popupIcon } from 'Assets/Icons'

const AccordionForMobile = ({ data, shouldShowBlur, getFreightHistoryData }) => {
  const { t } = useTranslation()
  const toast = useRef(null)

  const headerTemplate = (destinationPort, freightRateFrom, freightRateTo) => (
    <div className="accordion-heading-container">
      <div className="accordion-sub-heading">
        <div className="destinationPort-column">{destinationPort}</div>
        <div className="freightRate-between-column">
          <div className="freightRate-from-column">{freightRateFrom}</div>
          <div className="freightRate-to-column">{freightRateTo}</div>
        </div>
        <div>
          <DoubleArrowIcon />
        </div>
      </div>
    </div>
  )

  return (
    <div className="global-freightRate-mobile-view">
      <Toast ref={toast} />
      <div className="accordion-container">
        <div className="accordion-main-container">
          <div>{t('DESTINATION_PORTS')}</div>
          <div>{t('DIFFERENTIALS')}</div>
          <div>{t('BETWEEN')}</div>
          <div></div>
        </div>
        <Accordion>
          {data?.globalFreightRateData?.length > 0 &&
            data?.globalFreightRateData.map(({ destinationPort, freightRate, freightRateFrom, freightRateTo, loadingPort, others, transitPeriod }, index) => (
              <AccordionTab key={index} header={headerTemplate(destinationPort, freightRate, freightRateFrom, freightRateTo, loadingPort, others, transitPeriod)}>
                <div className="accordion-tab-container">
                  <div className="accordion-sub-tab-container">
                    <div>
                      <div className="each-data">
                        <div className="row-heading">{t('DESTINATION_PORTS')} :</div>
                        <div>{destinationPort}</div>
                      </div>
                      <div className="each-data">
                        <div className="row-heading">{t('LOADING_PORTS')} :</div>
                        <div>{loadingPort}</div>
                      </div>
                      <div className="each-data">
                        <div className="row-heading">{t('FREIGHT_RATE')} :</div>
                        <div>{freightRate}</div>
                      </div>{' '}
                      <div className="each-data">
                        <div className="row-heading">{t('FREIGHT_RATE_FROM')} :</div>
                        <div>{freightRateFrom}</div>
                      </div>{' '}
                      <div className="each-data">
                        <div className="row-heading">{t('FREIGHT_RATE_TO')} :</div>
                        <div>{freightRateTo}</div>
                      </div>{' '}
                      <div className="each-data">
                        <div className="row-heading">{t('TRANSIT_PERIOD')} :</div>
                        <div>{transitPeriod}</div>
                      </div>
                      <div className="each-data">
                        <div className="row-heading">{t('OTHERS')} :</div>
                        <div>{others}</div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="each-data historical-data data_for_date"
                    data-testid="historical-data-container"
                    onClick={() => {
                      if (!shouldShowBlur && getFreightHistoryData) {
                        getFreightHistoryData(loadingPort, destinationPort, others, { loadingPort, destinationPort, others })
                      }
                    }}
                    style={{
                      pointerEvents: shouldShowBlur ? 'none' : 'auto',
                      cursor: shouldShowBlur ? 'not-allowed' : 'pointer'
                    }}
                  >
                    {t('HISTORICAL_DATA')} <img className="popup-icon" src={popupIcon} alt="popup-icon" title="historical-image" />
                  </div>
                </div>
              </AccordionTab>
            ))}
        </Accordion>
      </div>
    </div>
  )
}

export default AccordionForMobile
